module.exports = ".navbar-toggle {\n  background-color: #333; }\n\n.navbar-brand {\n  color: #fff; }\n"